import { ConfluenceData } from "./confluence.data";
import React, { useMemo } from "react";
import { SimpleWidget } from "../../simple_widget";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { useCommonComponents } from "@me8eon/components";
import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
// @ts-ignore
import icon from './confluence.svg'

export const ConfluenceDisplay: DisplayData<ConfluenceData> =
    ({ rootId, id, data }: DisplayDataProps<ConfluenceData>) => {
        const { H1WithIconAndUrl, Html, Url } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const ClipHeight = useCommonComponents().ClipHeight;
        const newRootId = `${rootId}.${id}`;
        const titleAndUrl = useMemo(() => ({ title: data.title, url: data.url, icon }), [data.title, data.url]);
        return <DataLayout rootId={newRootId} className='confluence-data' layout={[1, 1, 2, 1]}>
            <H1WithIconAndUrl rootId={newRootId} attribute={translateLabelForData('name')} value={titleAndUrl} />
            {data.body ? <ClipHeight maxHeight='2rem' force={false}>
                {/*<HighlightKeyWords rootId={newRootId} attribute='title' value={data.title}/>*/}
                <Html rootId={newRootId} attribute={translateLabelForData('desc')} value={data.body} />
            </ClipHeight> : <></>}
            <Text rootId={newRootId} attribute={translateLabelForData('source')} value={data.type} />
            <Text rootId={newRootId} attribute={translateLabelForData('lastUpdate')} value={data.last_updated} />
            <Url rootId={newRootId} attribute={translateLabelForData('url')} value={data.url} />
        </DataLayout>;
    };


export const SimpleConfluenceOneLineDisplay: DisplayData<ConfluenceData> =
    ({ data, listItemClicked }: DisplayDataProps<ConfluenceData>) => {
        const { SearchListItem } = useRenderers();
        const titleAndUrl = useMemo(() =>
        ({
            title: data.title,
            icon,
            onClick: () => { listItemClicked && listItemClicked(data.title) }
        }), [data.title]);
        return (
            <SearchListItem rootId={data.title} attribute={translateLabelForData('name')} value={titleAndUrl} />
        )
    }

export const SimpleConfluenceWidget: DisplayDataWidget<ConfluenceData> =
    SimpleWidget<ConfluenceData>(['name', 'description'], ['title', 'body'], []);
